import { isSSR } from '#shared/utils/isSSR';

export function useQueryParams() {
  if (isSSR()) {
    const pageData = usePageData();
    return pageData.navigation?.queryParams ?? {};
  }

  // for CSR
  const params = new URLSearchParams(window.location.search);

  return Object.fromEntries(params.entries());
}
